import { A } from "hookrouter";
import React from "react";
import { useState } from "react";
import ProductionUserService from "services/production/ProductionUserService";
import { isNullOrWhiteSpace } from "utilities/StringUtility";

const CompleteReset: React.FC = () => {
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [accessKey, setAccessKey] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [confirmPassword, setConfirmPassword] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [formComplete, setFormComplete] = useState(false);

    return (
        <div className="col-sm-6 trm-login">
            <div className="box">
                {
                    !formComplete
                    &&
                    <div className="box-body">
                        <h2>Reset Password</h2>
                        <br />
                        {
                            errorMessage &&
                            <div>{errorMessage}</div>
                        }
                        <div className="form-group">
                            <label>Email Address</label>
                            <input type="text" className="form-control" placeholder="Email Address" onChange={(event) => { setEmailAddress(event.currentTarget.value); }} />
                        </div>
                        <div className="form-group">
                            <label>Access Key</label>
                            <input type="accessKey" className="form-control" placeholder="Access Key" onChange={(event) => { setAccessKey(event.currentTarget.value); }} />
                        </div>
                        <div className="form-group">
                            <label>New Password</label>
                            <input type="password" className="form-control" placeholder="New Password" onChange={(event) => { setPassword(event.currentTarget.value); }} />
                        </div>
                        <div className="form-group">
                            <label>Confirm New Password</label>
                            <input type="password" className="form-control" placeholder="Confirm New Password" onChange={(event) => { setConfirmPassword(event.currentTarget.value); }} />
                        </div>
                        <br />
                        <div className="form-group">
                            <button className="btn btn-primary" onClick={async () => {
                                const isError =
                                    (isNullOrWhiteSpace(emailAddress) ||
                                        isNullOrWhiteSpace(password) ||
                                        isNullOrWhiteSpace(confirmPassword) ||
                                        isNullOrWhiteSpace(accessKey) ||
                                        password !== confirmPassword)

                                if (!isError) {
                                    const result = await new ProductionUserService().completePasswordResetAsync(
                                        emailAddress,
                                        accessKey,
                                        password)
                                    if (result) {
                                        setFormComplete(true);
                                    }
                                    else {
                                        setErrorMessage("Password reset failed");
                                    }
                                }
                                else {
                                    setErrorMessage("All values are required");
                                }
                            }}>Submit</button>
                        </div>
                    </div>
                }
                {
                    formComplete &&
                    <div className="box-body">
                        <div>
                            <h4>Password updated successfully.</h4>
                            <p>Your password has successfully been updated, you are now ready to login <A href="/">click here</A></p>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default CompleteReset;